import { ReactElement } from 'react';
import { Th, Tr } from '@ff-it/ui';
import { useTable } from 'components/ControlledTable/context';
import { totalsHeaderRow } from './style.css';

export function TotalsHeader(): ReactElement | null {
  const { columns, data } = useTable();
  if (!data?.totals) {
    return null;
  }

  const firstTotal = columns.findIndex((c) => c.key in data.totals);
  if (firstTotal < 0) {
    return null;
  }

  // The "Total:" caption sits in the cell immediately left of the first total column. When a total column is first —
  // e.g. the user pinned it left or hid every column before it via the column config — there is no leading cell to host
  // the caption (labelIndex === -1), so it is intentionally omitted; the totals still render.
  const labelIndex = firstTotal - 1;

  return (
    <Tr variant="light" className={totalsHeaderRow}>
      {columns.map(({ key, cellProps, headerCellProps, render }, i) => {
        const isTotal = key in data.totals;
        const isLabel = !isTotal && i === labelIndex;
        const value = isTotal ? (render ? render(data.totals, -1, i) : data.totals[key]) : isLabel ? 'Total:' : null;
        return (
          <Th
            key={key}
            data-cellid={key}
            {...cellProps}
            {...headerCellProps}
            className={headerCellProps?.className || cellProps?.className}
            {...(isLabel && { textAlign: 'end' })}
          >
            {value as any}
          </Th>
        );
      })}
    </Tr>
  );
}
